import { render } from "./SaveOAuthClient.vue?vue&type=template&id=6ea3f680&scoped=true"
import script from "./SaveOAuthClient.vue?vue&type=script&lang=js"
export * from "./SaveOAuthClient.vue?vue&type=script&lang=js"

import "./oauth-client.scss?vue&type=style&index=0&id=6ea3f680&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea3f680"]])

export default __exports__